<template>
    <div>
        <div class="org-tree-layout" v-if="showOrgTree">
            <swb-popover-org-tree :showMgmt="showMgmt" :selectComId="filterItem.retailerComId" :showIncludeSubComs="showIncludeSubComs" :initIncludeSubComs="false" :bizDepart="bizDepart"
                                  @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <div v-if="useServcWork" class="tab-container small base mt10">
            <div class="tabs-nav">
                <ul class="head">
                    <li :class="{'current': tabClickValue == 'def_servicer'}" class="head-item" @click="handleTabClick('def_servicer')">
                        <span>特定可用资产</span>
                    </li>
                    <li :class="{'current': tabClickValue == 'contract_servicer'}" class="head-item" @click="handleTabClick('contract_servicer')">
                        <span>合同可用资产</span>
                    </li>
                </ul>
            </div>
        </div>
        <swb-query-sort-area name="query-sort-area" ref="query_sort_area" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler"
                             :popupHandler="popupHandler"></swb-query-sort-area>
        <swb-result-table class="mt10" name="result_table" :confKey="confKey" :configAuto="true" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :height="tableHeight" ref="result_table"
                          :needPager="true" :rowNoShow="true" :rowNoFixed="true" :rowNoAsSeqNo="true" :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'
    import {getDefaultPageSizes} from '../../app.conf'
    import {openShopDeviceSuitSelectDlg} from '../retailer/selectDlg'
    import {loadRetailerDevcGroupCascList} from '../retailer/asset-comn'
    import {getMerchtAssetNatureMap} from '../index'
    //
    import shopDevcApi from '../../api/shopDevc'
    import devcApi from '../../api/devc'
    import userApi from '../../api/user'

    import SwbResultTable from '../query/ResultTable'

    Vue.regist(SwbResultTable);

    export default {
        name: 'swb-shop-device-list-for-select',
        desc: '新设备选择列表',
        props: {
            // 设备数据过滤条件
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            // 是否多选-默认是
            checkBox: {
                type: Boolean,
                default: true
            },
            // 单选回显
            checkedItem: {
                type: Object,
                default: null
            },
            // 多选-初始选中的ids(禁用)
            initSelectIds: {
                type: Array,
                default: null
            },
            devcBizClolumType: {
                type: String,
                default: 'DefDlg'
            },
            showOrgTree: {
                type: Boolean,
                default: false
            },
            // showOrgTree == true, 有效
            showMgmt: {
                type: Boolean,
                default: false
            },
            // showOrgTree == true, 有效
            bizDepart: {
                type: Boolean,
                default: false
            },
            // 显示跨组织勾选(默认显示)  showOrgTree == true, 有效
            showIncludeSubComs: {
                type: Boolean,
                default: true
            },
            // 是否用于维保
            useServcWork: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                confKey: 'device-for-select-list-DefDlg',
                //
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                filterItem: {},
                tableHeight: 600, //表格高度
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: 'id', //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                //
                seprPeriodStateMap: getEnumMap('seprPeriodState', 'value2text'),
                acctEnterWayMap: getEnumMap('acctEnterWay', 'value2text'),
                devcVoucherTypeMap: getEnumMap('devcVoucherType', 'value2text'),
                assetNatureMap: getEnumMap('assetNature', 'value2text'),
                assetTypeMap: getEnumMap('assetType', 'value2text'),
                // 用于维保
                tabClickValue: 'def_servicer',
                totalCount: 0
            }
        },
        created: function () {
            let self = this;
            if (this.checkBox) {
                this.multiSelect = true;
                this.multiPageSelect = true;
            } else {
                this.multiSelect = false;
                this.multiPageSelect = false;
            }
            //
            this.filterItem = Utils.merge({}, this.filter);
            //
            this.confKey = 'device-for-select-list-' + this.devcBizClolumType;
            // 需要的信息
            this.pageSize = this.pageSizes.first();
            //
            this.getCurrentUserInfo();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            thisEl.addClass('overFlow-hidden');
            this.initResultTable();
            // 回显数据处理
            let resultTable = this.$refs.result_table;
            if (!Utils.isNoB(this.initSelectIds) && this.initSelectIds.length > 0) {
                let initChecked = Utils.merge([], this.initSelectIds);
                resultTable.setInitChecked(initChecked, true);
            } else if (!Utils.isNoB(this.checkedItem)) {
                let initChecked = Utils.merge({}, this.checkedItem);
                resultTable.setInitChecked(initChecked);
            }
        },
        beforeDestroy() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable() {
                let self = this;
                let resultTable = this.$refs['result_table'];
                let query_sort_area = this.$refs['query_sort_area'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_sort_area);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'lockBizType': function (row, colName, colValue, rowIndex, colConf) {
                        if (self.devcVoucherTypeMap[row.id] != null) {
                            return '<span class="font-red" >' + self.devcVoucherTypeMap[row.id] + '</span>';
                        }
                    },
                    'locked': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue) {
                            return ' <span class="font-green">是</span>';
                        } else {
                            return '<span >否</span>';
                        }
                    },
                    'statusLabel': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if (row.wrntDueTime != null && new Date(row.currentTime).getTime() > new Date(row.wrntDueTime).getTime()) {
                            domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">保外</a>';
//                            domHtml = domHtml + '<i class="swb-icon lr table-wrnt"></i>';
                        }
                        if (row.wrntDueTime == null || new Date(row.currentTime).getTime() <= new Date(row.wrntDueTime).getTime()) {
                            domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">保内</a>';
//                            domHtml = domHtml + '<i class="swb-icon lr table-unWrnt"></i>';
                        }
                        if (row.tagMissing != null && row.tagMissing) {
                            domHtml = domHtml + '<a class="swb-tags swb-tags-outlined">缺码</a>';
                        }
                        return domHtml;
                    },
                    'inStock': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue) {
                            return '<span class="font-green" >是</span>';
                        } else {
                            return '<span class="font-red">否</span>';
                        }
                    },
                    'indoubtFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue == 1) {
                            return '<span class="font-red" >是</span>';
                        }
                    },
                    'suitMainFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.suitId != null) {
                            if (colValue) {
                                return ' <span class="font-green">是</span>';
                            } else {
                                return '<span >否</span>';
                            }
                        } else {
                            return '';
                        }
                    },
                    'imported': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue) {
                            return ' <span class="font-green">是</span>';
                        } else {
                            return '<span >否</span>';
                        }
                    },
                    'specialFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue) {
                            return ' <span class="font-green">是</span>';
                        } else {
                            return '<span >否</span>';
                        }
                    },
                    'inUse': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue) {
                            return ' <span class="font-green">是</span>';
                        } else {
                            return '<span>否</span>';
                        }
                    },
                    'useState': function (row, colName, colValue, rowIndex, colConf) {
                        if (!row.started && row.useState == 0 && row.state == 0) {
                            return ' <span class="font-black">未启用</span>';
                        } else if (row.useState == 2) {
                            return '<span class="font-gold">已停用</span>';
                        } else if (row.useState == 1) {
                            return '<span class="font-green">已启用</span>'
                        }
                    },
                    'state': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue == 0) {
                            return '<span class="font-green" >正常</span>';
                        } else if (colValue == 1) {
                            return '<span class="font-red" >故障未报修</span>';
                        } else if (colValue == 2) {
                            return '<span class="font-black" >故障已报修</span>';
                        } else if (colValue == 3) {
                            return '<span class="font-black" >故障维修中</span>';
                        }
                    },
                    'scrapped': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue) {
                            return ' <span class="font-green">是</span>';
                        } else {
                            return '<span>否</span>';
                        }
                    },
                    'outageTimeMi': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue != null) {
                            return '<span>' + colValue + '</span>';
                        } else {
                            return '<span>0</span>';
                        }
                    },
                    'rented': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue) {
                            return ' <span class="font-green">是</span>';
                        } else {
                            return '<span>否</span>';
                        }
                    },
                    'fiscalAcctFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue) {
                            return ' <span class="font-green">是</span>';
                        } else {
                            return '<span>否</span>';
                        }
                    },
                    'acctEnterWay': function (row, colName, colValue, rowIndex, colConf) {
                        let acctEnterWay = self.acctEnterWayMap[colValue];
                        if (acctEnterWay != null) {
                            return '<span>' + acctEnterWay + '</span>';
                        }
                    },
                    'rmnWorthRatio': function (row, colName, colValue, rowIndex, colConf) {
                        if (colValue != null && colValue > 0) {
                            return '<span>' + colValue.toFixed(2) + '</span>';
                        } else {
                            return '<span>0.00</span>';
                        }
                    },
                    'orgWorth': function (row, colName, colValue, rowIndex, colConf) {

                        if (colValue != null && colValue > 0) {
                            return '<span>' + colValue.toFixed(2) + '</span>';
                        } else {
                            return '<span>0.00</span>';
                        }
                    },
                    'netWorth': function (row, colName, colValue, rowIndex, colConf) {

                        if (colValue != null && colValue > 0) {
                            return '<span>' + colValue.toFixed(2) + '</span>';
                        } else {
                            return '<span>0.00</span>';
                        }
                    },
                    'deprPeriod': function (row, colName, colValue, rowIndex, colConf) {
                        let deprPeriod = self.seprPeriodStateMap[colValue];
                        if (deprPeriod != null) {
                            return '<span>' + deprPeriod + '</span>';
                        }
                    },
                    'devcDefFlagName': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.devcDefId == -1) {
                            return '<span>未关联</span>';
                        } else {
                            return '<span>已关联</span>';
                        }
                    },
                    'temperFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.temperFlag) {
                            return '<span>需要</span>';
                        } else {
                            return '<span>不需要</span>';
                        }
                    },
                    'assetNature': function (row, colName, colValue, rowIndex, colConf) {
                        return '<span>' + self.assetNatureMap[colValue] + '</span>';
                    },
                    'assetType': function (row, colName, colValue, rowIndex, colConf) {
                        return '<span>' + self.assetTypeMap[colValue] + '</span>';
                    },
                    'allowAllotQuantity': function (row, colName, colValue, rowIndex, colConf) {
                        let quantity = 0;
                        if (self.devcBizClolumType == 'DiaoBoDlg') {
                            if (Utils.isTrue(self.filter.devcDiaoBoFlag)) {
                                quantity = row.existQuanity;
                            } else {
                                quantity = row.existQuanity - row.scrappedQuantity;
                            }
                        }
                        if (Utils.isNoB(quantity) || !Utils.isNumber(quantity) || quantity < 0) {
                            quantity = 0;
                        }
                        if (self.devcBizClolumType == 'ReserveDiaoBoDlg') {
                            if (row.assetIdleX) {
                                return quantity;
                            } else {
                                return 0;
                            }
                        } else {
                            return quantity;
                        }
                    },
                    'existQuanity': function (row, colName, colValue, rowIndex, colConf) {
                        if (self.devcBizClolumType == 'ReserveDiaoBoDlg') {
                            if (row.assetIdleX) {
                                return row.existQuanity;
                            } else {
                                return 0;
                            }
                        } else {
                            return row.existQuanity;
                        }
                    },
                    'allowScrapQuantity': function (row, colName, colValue, rowIndex, colConf) {
                        return row.fiscalQuantity - row.scrappedQuantity;
                    },
                    'allowDisposeQuantity': function (row, colName, colValue, rowIndex, colConf) {
                        return row.existQuanity - row.scrappedQuantity;
                    },
                    'lastDeprWorth': function (row, colName, colValue, rowIndex, colConf) {
                        let month = new Date().format('yyyyMM');
                        if (row.lastDeprMonth == month) {
                            return row.lastDeprWorth;
                        } else {
                            return null;
                        }
                    },
                    'durableYears': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.fiscalAcctFlag == 0) {
                            return row.durableYears || 0;
                        } else if (row.deprable) {
                            return (row.durableLife - row.leftMonths) || 0;
                        }
                    }
                });
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getTotalCount() {
                return this.totalCount;
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let data = result.data;
                        let scopeEntity = data.scopeEntity;
                        self.scopeEntity = scopeEntity;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            // 分页切换
            pageNoChangeHandler: function (pageNumber, pageSize) {
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDataList();
            },
            getDataList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems = Object.assign(filterItems, self.filterItem);
                filterItems.devcBizClolumType = this.devcBizClolumType;
                // 用于维保
                if (this.useServcWork) {
                    filterItems.selectType = this.tabClickValue;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                devcApi.getShopDeviceListByFilter(postData, function (result) {
                    theLoad.hide();
                    if (result.type === 'info') {
                        let data = result.data;
                        let list = data.rows || [];
                        self.totalCount = result.data.pagination.totalCount;
                        //
                        self.renderTable(list, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 渲染数据
            renderTable(rows, pagination) {
                //let resultColConfCmp = this.$refs['result_col_conf'];
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                // let confColList = resultColConfCmp.getMetaColList();
                //resultTable.initMeta(confColList);
                let dataMap = {
                    pagination: pagination,
                    rows: rows
                };
                //设置新数据
                resultTable.render(dataMap);
            },
            onQueryConfigReady() {
                let self = this;
                let query_model_ctrl = this.$refs['query_sort_area'];
                //
                if (!Utils.isNoB(self.filter.fiscalIgnored) && Utils.isFalse(self.filter.fiscalIgnored)) {
                    query_model_ctrl.updateFields({
                        fiscalIgnored: {
                            disabled: true,
                            hidden: true
                        }
                    });
                }
                if (!Utils.isNoB(self.filter.scrapped)) {
                    query_model_ctrl.updateFields({
                        scrapped: {
                            disabled: true,
                            hidden: true
                        }
                    });
                }
                // 入账方式
                let acctEnterWay = getEnumList('acctEnterWay');
                let acctEnterWayDataList = [];
                if (acctEnterWay != null && acctEnterWay.length > 0) {
                    acctEnterWay.forEach(function (item) {
                        let queryAcctEnterWay = {};
                        queryAcctEnterWay.value = item.value;
                        queryAcctEnterWay.label = item.text;
                        acctEnterWayDataList.push(queryAcctEnterWay);
                    });
                }
                query_model_ctrl.updateFields({
                    acctEnterWay: {
                        dataList: acctEnterWayDataList
                    }
                });
                loadRetailerDevcGroupCascList(function (dataList) {
                    self.updateQueryModelField('devcGroupId', dataList);
                });
                //
                this.getDevcCatList(function (devcCatList) {
                    let dataList = [];
                    devcCatList.forEach(function (devcCat) {
                        dataList.push({
                            'value': devcCat.id,
                            'label': devcCat.name + '(' + devcCat.code + ')'
                        });
                    });
                    self.updateQueryModelField('innerDevcCatId', dataList);
                });
                // 资产属性
                getMerchtAssetNatureMap((merchtAssetNatureList) => {
                    if (merchtAssetNatureList.length > 0) {
                        let dataList = [{'value': null, 'label': '- 全部 -'}];
                        merchtAssetNatureList.forEach(function (item) {
                            let dataInfo = {};
                            dataInfo.value = item.value;
                            dataInfo.label = item.text;
                            dataList.push(dataInfo);
                        });
                        this.updateQueryModelField('assetNature', dataList);
                    }
                });
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if (itemCode != null) {
                    let query_model_ctrl = this.$refs['query_sort_area'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            getDevcCatList(callback) {
                shopDevcApi.getDevcCatList({
                    level: 3,
                    disabled: false,
                    auditState: 1,
                }, function (result) {
                    if (result.type == 'info') {
                        let srcDevcCatList = result.data;
                        let devcCatList = [];
                        srcDevcCatList.forEach(function (item) {
                            devcCatList.push(item);
                        });
                        callback(devcCatList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDataList();
            },
            popupHandler: function (fieldCode, curValue, curText) {
                if (fieldCode == 'suitIds') {
                    let query_model_ctrl = this.$refs['query_sort_area'];
                    let params = {};
                    //
                    if (Utils.isNoB(this.filterItem) || Utils.isNoB(this.filterItem.retailerComId)) {
                        params.thisComId = this.scopeEntity.comId;
                        params.includeSubComs = false;
                    } else {
                        params.thisComId = this.filterItem.retailerComId;
                        params.includeSubComs = this.filterItem.includeSubComs;
                    }
                    //
                    openShopDeviceSuitSelectDlg(params, function (suitList) {
                        let suitIdList = suitList.pluck('id');
                        let suitNameList = suitList.pluck('name');
                        //
                        let suitIds = suitIdList.join('_');
                        let suitNames = suitNameList.join('、');
                        //
                        let fieldInfo = {
                            suitIds: {
                                value: suitIds,
                                text: suitNames
                            }
                        };
                        query_model_ctrl.updateFields(fieldInfo);
                    });
                }
            },
            checkComCatChange: function (eventData) {
                if (eventData.id != this.filterItem.retailerComId || eventData.includeSubComs != this.filterItem.includeSubComs) {
                    this.filterItem.retailerComId = eventData.id;
                    this.filterItem.includeSubComs = eventData.includeSubComs;
                    this.filterItem = Utils.merge({}, this.filterItem);
                    this.pageNoChangeHandler(1, this.pageSize);
                }
            },
            handleTabClick(val) {
                if (this.tabClickValue != val) {
                    this.tabClickValue = val;
                    this.pageNumber = 1;
                    this.getDataList();
                }
            },
            getDlgResult: function () {
                let result = {};
                //
                let checkBox = this.checkBox;
                if (checkBox) {
                    let selectionList = this.getTableSelection() || [];
                    if (selectionList.length > 0) {
                        result.type = 'info';
                        result.data = selectionList;
                    } else {
                        result.type = 'warn';
                        result.message = '请选择资产信息';
                    }
                } else {
                    let checkedItem = this.getTableSelection();
                    if (!Utils.isNoB(checkedItem) && !Utils.isNoB(checkedItem.id)) {
                        result.type = 'info';
                        result.checkedId = checkedItem.id || null;
                        result.data = checkedItem;
                    } else {
                        result.type = 'warn';
                        result.message = '请选择资产信息';
                    }
                }
                return result;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devc/ShopDeviceListForSelect.vue